/**
 * Minimal useUserRole hook for Identity Module.
 * 
 * The identity module doesn't need full user role functionality.
 * This is a stub that provides compatibility with imports.
 */

export type UserRole = 
  | "admin" 
  | "engineer" 
  | "user" 
  | "change_manager" 
  | "analyst" 
  | "end_user"
  | "incident_manager"
  | "problem_manager"
  | "service_owner"
  | "sla_manager"
  | "approver";

export const useUserRole = () => {
  return { 
    role: null as UserRole | null, 
    loading: false, 
    hasRole: (_requiredRole: UserRole | UserRole[]) => false, 
    isAdmin: false, 
    isEngineer: false, 
    isUser: false, 
    isAnalyst: false, 
    isEndUser: false, 
    isChangeManager: false,
    isIncidentManager: false,
    isProblemManager: false,
    isServiceOwner: false,
    isSLAManager: false,
    isApprover: false
  };
};
